<template>
  <div
    v-if="petition"
    class="bg-black"
  >
    <section
      id="sign"
      class="relative w-full h-auto"
    >
      <AppImage
        :path="`/img/gallery/${petition.image.file_name}`"
        :eager="true"
        :alt="petition.image.alt"
        :credit="petition.image.credit"
        class="md:absolute inset-0 w-full h-full"
        img-classes="md:brightness-[0.30]"
      />
      <UContainer class="z-10 relative flex flex-col gap-6 mx-auto lg:px-8 max-lg:px-2 max-md:py-6 md:py-40 w-full max-w-7xl h-full">
        <AppLogo
          class="z-10 relative lg:self-end max-lg:self-center"
          :light="false"
        />

        <div class="relative flex lg:flex-row max-lg:flex-col lg:justify-between max-lg:justify-center items-center gap-4 w-full">
          <div class="flex flex-col justify-start items-start gap-4 max-w-xl grow">
            <p
              class="bg-white dark:bg-neutral-600 px-4 py-2 rounded-sm font-semibold max-md:text-4xl md:text-5xl uppercase"
              v-text="t('pages.frontpage.petition')"
            />
            <h1
              class="font-semibold text-white max-md:text-2xl md:text-4xl"
              v-text="petition.title"
            />
            <p
              class="text-white max-md:text-md md:text-lg"
              v-text="petition.description"
            />
            <p
              class="text-white text-sm"
            >
              {{ t('pages.frontpage.do_not_want_to_sign') }}, <UButton
                variant="link"
                color="inherit"
                size="md"
                class="p-0"
                :to="default_to_organisations ? '/org/contact' : '/people/contact'"
                :label="t('pages.frontpage.show_one_time_help_page')"
                @click="event({ google: 'skip_to_contact' })"
              />.
            </p>
          </div>
          <UCard
            :ui="{
              root: 'max-w-[460px] rounded-[calc(var(--ui-radius)*2)]',
              body: 'flex flex-col gap-4',
            }"
          >
            <LayoutProgressBar :sf-campaign-id="petition.sf_campaign_id" />
            <FormSign
              :sf-campaign-id="petition.sf_campaign_id"
              redirect-path="/confirm-email"
              sign-path="/user"
              :disable-newsletter-option="true"
            />
          </UCard>
        </div>
      </UContainer>
    </section>
    <LayoutBox
      v-for="(section, index) in petition.sections"
      :key="section.title1"
      :image-path="`${image_folder_path}${section.image.file_name}`"
      :image-alt="section.image.alt"
      :image-credit="section.image.credit"
      :title1="section.title1"
      :title2="section.title2"
      :text="section.description"
      :align-right="index % 2 === 1"
    />
    <AppFooter :light="true" />
    <OtherReturnError />
  </div>
  <div v-else>
    <h1>Data missing</h1>
  </div>
</template>

<script lang="ts" setup>
const { petition, data: { default_to_organisations } } = getData()
const image_folder_path = '/img/gallery/'

const { event } = useTracker()
</script>
